frappe.provide('webcommerce.shop');

webcommerce.shop = {
    config: {},

    init: function() {
        this.initializeBannerCarousel();
        this.initializeCountdown();
        this.initializeProductSearch();
    },

    initializeBannerCarousel: function() {
        const bannerCarousel = document.getElementById('banner-carousel');
        if (bannerCarousel && typeof Glide !== 'undefined') {
            new Glide('#banner-carousel', {
                type: 'carousel',
                startAt: 0,
                perView: 1,
                gap: 0,
                autoplay: 5000,
                hoverpause: true,
                animationDuration: 600,
                animationTimingFunc: 'ease-in-out'
            }).mount();
        }
    },

    initializeFlashSaleCarousel: function() {
    },

    initializeFeaturedCarousel: function() {
    },

    initializeCarousels: function() {
        this.initializeBannerCarousel();
    },

    initializeCountdown: function() {
        const countdownElement = document.getElementById('flash-sale-countdown');
        if (countdownElement) {
            this.startClientCountdown();
        }
    },

    startClientCountdown: function() {
        const updateCountdown = () => {
            frappe.call({
                method: 'tos_webcommerce.templates.pages.shop.get_flash_sale_countdown',
                async: true,
                callback: (r) => {
                    if (r.message) {
                        const { days, hours, minutes, seconds } = r.message;
                        this.updateCountdownDisplay(days, hours, minutes, seconds);
                    } else {
                        const countdownElement = document.getElementById('flash-sale-countdown');
                        if (countdownElement) {
                            countdownElement.innerHTML = `
                                <div class="text-center py-4">
                                    <span class="text-xl font-semibold">Flash Sale Ended!</span>
                                </div>
                            `;
                        }
                    }
                }
            });
        };

        updateCountdown();

        let lastUpdate = Date.now();
        setInterval(() => {
            const now = Date.now();
            if (now - lastUpdate >= 30000) {
                updateCountdown();
                lastUpdate = now;
            } else {
                this.decrementCountdown();
            }
        }, 1000);
    },

    updateCountdownDisplay: function(days, hours, minutes, seconds) {
        const daysEl = document.getElementById('days');
        const hoursEl = document.getElementById('hours');
        const minutesEl = document.getElementById('minutes');
        const secondsEl = document.getElementById('seconds');

        if (daysEl) daysEl.textContent = String(days).padStart(2, '0');
        if (hoursEl) hoursEl.textContent = String(hours).padStart(2, '0');
        if (minutesEl) minutesEl.textContent = String(minutes).padStart(2, '0');
        if (secondsEl) secondsEl.textContent = String(seconds).padStart(2, '0');
    },

    decrementCountdown: function() {
        const secondsEl = document.getElementById('seconds');
        const minutesEl = document.getElementById('minutes');
        const hoursEl = document.getElementById('hours');
        const daysEl = document.getElementById('days');

        if (!secondsEl) return;

        let seconds = parseInt(secondsEl.textContent) || 0;
        let minutes = parseInt(minutesEl?.textContent) || 0;
        let hours = parseInt(hoursEl?.textContent) || 0;
        let days = parseInt(daysEl?.textContent) || 0;

        seconds--;

        if (seconds < 0) {
            seconds = 59;
            minutes--;
        }
        if (minutes < 0) {
            minutes = 59;
            hours--;
        }
        if (hours < 0) {
            hours = 23;
            days--;
        }
        if (days < 0) {
            days = 0;
            hours = 0;
            minutes = 0;
            seconds = 0;
        }

        this.updateCountdownDisplay(days, hours, minutes, seconds);
    },

    initializeProductSearch: function() {
        const searchBox = document.getElementById('search-box');
        if (searchBox) {
            searchBox.addEventListener('keypress', function(e) {
                if (e.key === 'Enter') {
                    e.target.form.submit();
                }
            });
        }
    }
};

document.addEventListener('DOMContentLoaded', function() {
    webcommerce.shop.init();
});

function applySorting(sortValue) {
    const url = new URL(window.location.href);
    url.searchParams.set('sort', sortValue);
    url.searchParams.delete('page');
    window.location.href = url.toString();
}

function applyCategory(categoryValue) {
    const url = new URL(window.location.href);
    if (categoryValue) {
        url.searchParams.set('category', categoryValue);
    } else {
        url.searchParams.delete('category');
    }
    url.searchParams.delete('page');
    window.location.href = url.toString();
}
